module.exports = __webpack_public_path__ + "img/card_bg1@2x.b4dee5dd.png";